import React from 'react';
import ErrorTemplate from '../ErrorTemplate';

class Error401 extends React.Component {
  render() {
    return (
      <div>     
     
         <ErrorTemplate
        errorCode="401"
        errorMessage="Unauthorized: Please ensure you have permissions before accessing this page."
      />
      </div>

    );
  }
}

export default Error401;